module.exports = __webpack_public_path__ + "img/27_51.3505c63a.png";